module.exports = {
  realpathSync: {
    native: {},
  },
};
